<template>
  <div class="modal fade" id="with-draw-modal" tabindex="-1" role="dialog" aria-labelledby="with-draw-modal"
       :class="{'zh-style' : currentLang === 'zh', 'disabled-style' : insufficientCommission}">
    <div :class="['modal-dialog', {'success-modal': withdrawSuccess}]" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <button class="close" data-dismiss="modal">
            <span>
              <svg class="icon">
                <use xlink:href="#icon-close"></use>
              </svg>
            </span>
          </button>
        </div>

        <template v-if="!withdrawSuccess">
          <div class="modal-body" v-if="currentLang === 'zh'">
            <h4>{{ $t('myReward') }} {{ $t(currentSymbol) }}{{ user.balance }}</h4>
            <p><input type="text" placeholder="PayPal账号" v-model="paymentId" name="account"
                      v-validate="'required'"
                      @blur="showAliPayAccountError = true"
                      @focus="showAliPayAccountError = false"
                      :class="{'danger-border': aliPayInputDanger}"
                      :disabled="insufficientCommission"></p>
            <p class="error-info">
              <span v-if="showAliPayAccountError && errors.has('account')">{{ errors.first('account') }}</span>
              <span v-else-if="showAliPayAccountError"></span>{{ aliPayAccountErrorMsg }}
            </p>
            <p class="min-amount">{{ $t('minAmount') }}</p>
          </div>

          <div class="modal-body" v-else>
            <h4>{{ $t('myReward') }} {{ $t(currentSymbol) }}{{ user.balance }}</h4>
            <p><input type="text" placeholder="PayPal account" v-model="paymentId" name="account"
                      v-validate="'required'"
                      @blur="showPayPalAccountError = true"
                      @focus="showPayPalAccountError = false"
                      :class="{'danger-border' : payPalInputDanger}"
                      :disabled="insufficientCommission"></p>
            <p class="error-info">
              <span v-if="showPayPalAccountError && errors.has('account')">{{ errors.first('account') }}</span>
              <span v-else-if="showPayPalAccountError"></span>{{ payPalAccountErrorMsg }}
            </p>
            <p class="min-amount">{{ $t('minAmount') }}</p>
          </div>
          <div class="modal-footer">
            <button @click="withdraw" v-show="!loading" :disabled="insufficientCommission">{{ $t('submit') }}</button>
            <spinner :show="loading" class="spinner-component"></spinner>
          </div>
        </template>
        <template v-else>
          <div class="modal-body">
            <p class="success-notice">{{ $t('your') }} {{ $t(currentSymbol) }}{{ user.balance }}{{ $t('transferAccounts') }} {{ paymentId }} <span>{{ user.nickname }}</span> {{ $t('expirationDate') }}</p>
          </div>
          <div class="modal-footer">
            <button data-dismiss="modal">{{ $t('ok') }}</button>
          </div>
        </template>

      </div>
    </div>

  </div>
</template>

<script>
  import locales from './lang'
  import Spinner from '../Spinner.vue'
  import $ from 'jquery'
  import { mapState } from 'vuex'

  export default {
    name: 'withdraw',
    components: {Spinner},
    data: function () {
      return {
        reallyName: '',
        paymentId: '',
        loading: false,
        showNameError: false,
        nameErrorMsg: '',
        showAliPayAccountError: false,
        aliPayAccountErrorMsg: '',
        showPayPalAccountError: false,
        payPalAccountErrorMsg: '',
        withdrawSuccess: false
      }
    },
    locales,
    computed: {
      nameInputDanger() {
        return this.showNameError && (this.errors.has('name') || this.nameErrorMsg)
      },
      aliPayInputDanger() {
        return this.showAliPayAccountError && (this.errors.has('account') || this.aliPayAccountErrorMsg)
      },
      payPalInputDanger() {
        return this.showPayPalAccountError && (this.errors.has('account') || this.payPalAccountErrorMsg)
      },
      paymentMethod() {
        return this.currentLang === 'zh' ? 'paypal' : 'paypal'
      },
      insufficientCommission() {
        if (this.currentLang === 'zh') {
          return this.user.balance < 100
        } else {
          return this.user.balance < 50
        }
      },
      ...mapState({
        currentLang: state => state.currentLang,
        user: state => state.user,
        currentSymbol: state => state.currentSymbol
      })
    },
    mounted() {
      let _this = this
      $('#with-draw-modal').on('hidden.bs.modal', function () {
        if (_this.withdrawSuccess) {
          _this.$store.dispatch('getCommissionInfo')
        }
        _this.aliPayAccountErrorMsg = ''
        _this.payPalAccountErrorMsg = ''
        _this.withdrawSuccess = false
      })
    },
    methods: {
      withdraw() {
        this.loading = true
        this.showNameError = true
        this.showAliPayAccountError = true
        this.showPayPalAccountError = true
        if (this.errors.errors.length > 0) {
          this.loading = false
          return
        }
        this.$validator.validateAll().then(success => {
          if (!success) {
            this.loading = false
            return
          }
          this.$http.patch('api/withdraw', {
            name: this.reallyName,
            payment_id: this.paymentId,
            payment_method: this.paymentMethod
          }).then((response) => {
            this.loading = false
            switch (response.data.code) {
              case 0: {
                this.withdrawSuccess = true
                break
              }
              default: {
                this.aliPayAccountErrorMsg = response.data.message
                this.payPalAccountErrorMsg = response.data.message
                break
              }
            }
          })
        })
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/reset-modal";
  @import "../../assets/scss/mixins/button";
  @import "../../assets/scss/variables";

  .modal-dialog {
    @include modal-dialog($height: 3.71rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 1.855rem) 0 0 -45% !important;
    }
  }

  .success-modal {
    @include modal-dialog($height: 3.22rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 1.61rem) 0 0 -45% !important;
    }
  }

  .zh-style {
    .modal-dialog {
      @include modal-dialog($height: 4.8rem);
      @media (max-width: 767px) {
        margin: calc(50vh - 2.4rem) 0 0 -45% !important;
      }
    }
    .success-modal {
      @include modal-dialog($height: 2.94rem);
      @media (max-width: 767px) {
        margin: calc(50vh - 1.47rem) 0 0 -45% !important;
      }
    }
  }

  .modal-dialog {
    text-align: center;
    input {
      text-align: left;
    }
  }
  .modal-body {
    width: calc(100% - .4rem);
    margin: 0 auto;
    @media (max-width: 767px) {
      width: 100%;
    }
    h4 {
      font-size: .24rem;
      color: #333333;
      letter-spacing: 0;
      margin-bottom: .4rem;
    }
    input {
      border: 1px solid #EFEFEF;
      width: 100%;
      height: .6rem;
      line-height: .6rem;
      padding: 0 .2rem;
      font-size: .16rem;
      color: #333;
      letter-spacing: 0;
      outline: none;
      &:focus {
        outline: none;
      }
      &::-webkit-input-placeholder {
        color: #999;
      }
      &::-moz-placeholder {
        color: #999;
      }
      &:-ms-input-placeholder {
        color: #999;
      }
    }
    .error-info {
      width: 100%;
      text-align: right;
      font-size: .12rem;
      color: #FC5A5A;
      margin-top: .1rem;
      line-height: .14rem;
      min-height: .14rem;
      word-wrap: break-word;
      letter-spacing: 0.7px;
      margin-bottom: .16rem;
    }
    .min-amount {
      color: #999;
      margin-bottom: .6rem;
    }
  }
  .modal-footer {
    button {
      @include modal-button();
      display: block;
    }
    * {
      margin: 0 auto;
    }
  }

  .success-modal {
    .modal-body {
      margin-bottom: .6rem;
      p.success-notice {
        min-height: 1.12rem;
        height: 1.12rem;
        vertical-align: middle;
        display: table-cell;
        font-size: .14rem;
        color: #333333;
        letter-spacing: 0.62px;
        line-height: .28rem;
        span {
          color: $base-blue;
        }
      }
    }
  }

  .disabled-style {
    .modal-footer {
      button {
        background: #D5D5D5;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Index.vue?11c07c50